import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "pool-page"
};
const _hoisted_2 = {
  key: 0,
  class: "error-message"
};
const _hoisted_3 = {
  class: "limit-up-container"
};
const _hoisted_4 = {
  class: "dashboard-card limit-up"
};
const _hoisted_5 = {
  class: "limit-table-wrapper"
};
const _hoisted_6 = {
  class: "limit-table"
};
const _hoisted_7 = {
  class: "sort-icon"
};
const _hoisted_8 = {
  class: "sort-icon"
};
const _hoisted_9 = {
  class: "sort-icon"
};
const _hoisted_10 = {
  class: "sort-icon"
};
const _hoisted_11 = {
  class: "sort-icon"
};
const _hoisted_12 = {
  class: "sort-icon"
};
const _hoisted_13 = {
  class: "sort-icon"
};
const _hoisted_14 = {
  class: "sort-icon"
};
const _hoisted_15 = {
  class: "sort-icon"
};
const _hoisted_16 = {
  class: "sort-icon"
};
const _hoisted_17 = {
  class: "index-cell"
};
const _hoisted_18 = {
  class: "stock-name-cell"
};
import { ref, onMounted, onBeforeUnmount, computed } from 'vue';
export default {
  __name: 'Pool',
  setup(__props) {
    const limitUpStocks = ref([]);
    const isOffline = ref(false);
    let fetchInterval = null;

    // 添加数字格式化方法 (from BigFish.vue)
    const formatLargeNumber = value => {
      if (!value) return '0';
      if (value >= 100000000) {
        return `${Math.floor(value / 100000000)}亿`;
      }
      if (value >= 10000) {
        return `${Math.floor(value / 10000)}万`;
      }
      return value.toString();
    };

    // 格式化百分比 (from BigFish.vue)
    const formatPercent = value => {
      if (value === undefined || value === null) return '0%';
      return value.toFixed(2) + '%';
    };

    // 格式化金额 (from BigFish.vue)
    const formatAmount = value => {
      if (!value) return '0';
      return value >= 100000000 ? (value / 100000000).toFixed(2) + '亿' : (value / 10000).toFixed(0) + '万';
    };
    const updateLimitUpData = data => {
      if (!data) return;
      limitUpStocks.value = data.map(stock => {
        return {
          ...stock,
          surge_reason: stock.surge_reason || {},
          formatted_amount: formatLargeNumber(stock.amount),
          highlight: stock.change_percent >= 9.9 || stock.change_percent <= -9.9
        };
      });
    };
    const fetchData = async () => {
      try {
        // 涨停池数据
        const limitUpResponse = await fetch('https://flash-api.xuangubao.com.cn/api/pool/detail?pool_name=limit_up', {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          mode: 'cors'
        });
        const limitUpData = await limitUpResponse.json();
        if (limitUpData && limitUpData.data) {
          updateLimitUpData(limitUpData.data);
        }
        isOffline.value = false;
      } catch (error) {
        console.error('数据获取失败:', error);
        isOffline.value = true;
      }
    };

    // 添加排序相关的状态 (from BigFish.vue)
    const sortConfig = ref({
      key: 'last_limit_up',
      // 默认按最后封板时间排序
      order: 'desc' // 'asc' 或 'desc'
    });

    // 排序方法 (from BigFish.vue)
    const handleSort = key => {
      if (sortConfig.value.key === key) {
        sortConfig.value.order = sortConfig.value.order === 'asc' ? 'desc' : 'asc';
      } else {
        sortConfig.value.key = key;
        sortConfig.value.order = 'desc';
      }
    };

    // 获取排序图标 (from BigFish.vue)
    const getSortIcon = key => {
      if (sortConfig.value.key !== key) return '⇅';
      return sortConfig.value.order === 'asc' ? '↑' : '↓';
    };

    // 修改时间格式化函数 (from BigFish.vue)
    const formatTime = timestamp => {
      if (!timestamp) return '-';
      const date = new Date(timestamp * 1000); // 将秒转换为毫秒
      return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
    };

    // 排序后的股票列表 (from BigFish.vue)
    const sortedStocks = computed(() => {
      const {
        key,
        order
      } = sortConfig.value;
      return [...limitUpStocks.value].sort((a, b) => {
        let valueA = a[key];
        let valueB = b[key];

        // 特殊处理某些字段
        if (key === 'flow_capital' || key === 'total_capital') {
          valueA = Number(valueA) || 0;
          valueB = Number(valueB) || 0;
        }
        if (order === 'asc') {
          return valueA > valueB ? 1 : -1;
        } else {
          return valueA < valueB ? 1 : -1;
        }
      });
    });
    onMounted(() => {
      fetchData();
      fetchInterval = setInterval(fetchData, 60000); // 60秒更新一次
    });
    onBeforeUnmount(() => {
      if (fetchInterval) {
        clearInterval(fetchInterval);
      }
    });
    return (_ctx, _cache) => {
      const _component_a_popover = _resolveComponent("a-popover");
      return _openBlock(), _createElementBlock("main", _hoisted_1, [isOffline.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, "数据获取失败")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createElementVNode("section", _hoisted_4, [_cache[22] || (_cache[22] = _createElementVNode("div", {
        class: "card-header"
      }, [_createElementVNode("h2", null, "池子里的鱼")], -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("table", _hoisted_6, [_createElementVNode("thead", null, [_createElementVNode("tr", null, [_cache[20] || (_cache[20] = _createElementVNode("th", null, null, -1)), _cache[21] || (_cache[21] = _createElementVNode("th", null, "股票名称", -1)), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[0] || (_cache[0] = $event => handleSort('price'))
      }, [_cache[10] || (_cache[10] = _createTextVNode(" 最新价 ", -1)), _createElementVNode("span", _hoisted_7, _toDisplayString(getSortIcon('price')), 1)]), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[1] || (_cache[1] = $event => handleSort('change_percent'))
      }, [_cache[11] || (_cache[11] = _createTextVNode(" 涨跌幅 ", -1)), _createElementVNode("span", _hoisted_8, _toDisplayString(getSortIcon('change_percent')), 1)]), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[2] || (_cache[2] = $event => handleSort('buy_lock_volume_ratio'))
      }, [_cache[12] || (_cache[12] = _createTextVNode(" 封单比 ", -1)), _createElementVNode("span", _hoisted_9, _toDisplayString(getSortIcon('buy_lock_volume_ratio')), 1)]), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[3] || (_cache[3] = $event => handleSort('turnover_ratio'))
      }, [_cache[13] || (_cache[13] = _createTextVNode(" 换手率 ", -1)), _createElementVNode("span", _hoisted_10, _toDisplayString(getSortIcon('turnover_ratio')), 1)]), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[4] || (_cache[4] = $event => handleSort('non_restricted_capital'))
      }, [_cache[14] || (_cache[14] = _createTextVNode(" 流通市值 ", -1)), _createElementVNode("span", _hoisted_11, _toDisplayString(getSortIcon('non_restricted_capital')), 1)]), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[5] || (_cache[5] = $event => handleSort('total_capital'))
      }, [_cache[15] || (_cache[15] = _createTextVNode(" 总市值 ", -1)), _createElementVNode("span", _hoisted_12, _toDisplayString(getSortIcon('total_capital')), 1)]), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[6] || (_cache[6] = $event => handleSort('first_limit_up'))
      }, [_cache[16] || (_cache[16] = _createTextVNode(" 首次封板 ", -1)), _createElementVNode("span", _hoisted_13, _toDisplayString(getSortIcon('first_limit_up')), 1)]), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[7] || (_cache[7] = $event => handleSort('last_limit_up'))
      }, [_cache[17] || (_cache[17] = _createTextVNode(" 最后封板 ", -1)), _createElementVNode("span", _hoisted_14, _toDisplayString(getSortIcon('last_limit_up')), 1)]), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[8] || (_cache[8] = $event => handleSort('break_limit_up_times'))
      }, [_cache[18] || (_cache[18] = _createTextVNode(" 开板 ", -1)), _createElementVNode("span", _hoisted_15, _toDisplayString(getSortIcon('break_limit_up_times')), 1)]), _createElementVNode("th", {
        class: "sortable",
        onClick: _cache[9] || (_cache[9] = $event => handleSort('limit_up_days'))
      }, [_cache[19] || (_cache[19] = _createTextVNode(" 连板 ", -1)), _createElementVNode("span", _hoisted_16, _toDisplayString(getSortIcon('limit_up_days')), 1)])])]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedStocks.value, (stock, index) => {
        var _stock$surge_reason;
        return _openBlock(), _createElementBlock("tr", {
          key: stock.symbol
        }, [_createElementVNode("td", _hoisted_17, _toDisplayString(index + 1), 1), _createElementVNode("td", null, [_createVNode(_component_a_popover, {
          placement: "left",
          content: (_stock$surge_reason = stock.surge_reason) === null || _stock$surge_reason === void 0 ? void 0 : _stock$surge_reason.stock_reason,
          trigger: "hover"
        }, {
          content: _withCtx(() => {
            var _stock$surge_reason2;
            return [_createElementVNode("p", null, _toDisplayString((_stock$surge_reason2 = stock.surge_reason) === null || _stock$surge_reason2 === void 0 ? void 0 : _stock$surge_reason2.stock_reason), 1)];
          }),
          default: _withCtx(() => [_createElementVNode("span", _hoisted_18, _toDisplayString(stock.stock_chi_name), 1)]),
          _: 2
        }, 1032, ["content"])]), _createElementVNode("td", null, _toDisplayString(stock.price), 1), _createElementVNode("td", {
          class: _normalizeClass({
            'up': stock.change_percent > 0,
            'down': stock.change_percent < 0
          })
        }, _toDisplayString(formatPercent(stock.change_percent * 100)), 3), _createElementVNode("td", null, _toDisplayString(formatPercent((stock.buy_lock_volume_ratio || 0) * 100)), 1), _createElementVNode("td", null, _toDisplayString(formatPercent((stock.turnover_ratio || 0) * 100)), 1), _createElementVNode("td", null, _toDisplayString(formatAmount(stock.non_restricted_capital)), 1), _createElementVNode("td", null, _toDisplayString(formatAmount(stock.total_capital)), 1), _createElementVNode("td", null, _toDisplayString(formatTime(stock.first_limit_up)), 1), _createElementVNode("td", null, _toDisplayString(formatTime(stock.last_limit_up)), 1), _createElementVNode("td", null, _toDisplayString(stock.break_limit_up_times || 0), 1), _createElementVNode("td", null, _toDisplayString(stock.limit_up_days || 1), 1)]);
      }), 128))])])])])])]);
    };
  }
};